const Selectors = {
  widget: {
    target: ".cb-bookingengine",
    waitFor: '[data-testid="header"]',
    mobileWidgetTarget: '[data-testid="header"]', //[aria-modal="true"]
    currency: '[data-testid="currency-selector"]',
    widgetDesktop: "#gustbook-widget-desktop",
    widget: "#guestbook-widget",
    stickyWidget: "#guestbook-sticky-widget",
  },
  ratesPage: {
    waitFor: ".cb-accommodations-page",
    contentChangeTarget: ".cb-accommodations-page",
    rates: ".cb-rate-plan-price",
    ratesCodes: ".cb-rate-plan > div > .chakra-stack > div:first-child > div:nth-child(1)",
    ratesMessage: ".gb-rates-message",
    currency: '[data-testid="currency-selector"]',
  },
  paymentPage: {
    waitFor: '[data-testid="shopping-cart-subtotal"]',
    contentChangeTarget: '.cb-property-info, reach-portal, [data-testid^="shopping-cart-item-accommodation"], [data-testid="shopping-cart-summary-total"]',
    currency: '[data-testid="currency-selector"]',
    checkin: '[data-testid="header-search-panel-date-picker-checkin-input"]',
    checkout: '[data-testid="header-search-panel-date-picker-checkout-input"]',
    firstname: '[data-testid="guest-form-first-name-input"]',
    lastname: '[data-testid="guest-form-last-name-input"]',
    email: '[data-testid="guest-form-email-input"]',
    subtotal: '[data-testid="shopping-cart-subtotal"]',
    mobileSubtotal: '[data-testid="shopping-cart-summary-total"]',
    total: ".cb-card.cb-shopping-cart > div:nth-child(4) > div:nth-child(4) > div > div:nth-child(3), [data-testid='shopping-cart-banner-grand-total']",
    enrollmentTarget: "#email-input, [type=email]",
    saveInfoTarget: '[data-testid="shopping-cart-confirm-button"], [data-testid="shopping-cart-summary-confirm-button"], [data-testid="shopping-cart-banner-confirm-button"]',
    enrollmentMessageContainer: "#guestbook-enrollment",
    roomNames: '[data-testid^="shopping-cart-item-name-accommodation"]',
    rateNames: '[data-testid^="shopping-cart-item-description-accommodation"]',
  },
  confirmationPage: { 
    waitFor: '.cb-confirmation-page [data-icon="angle-down"]',
    messageTarget: '[data-testid="purchased-accommodations-list"]', 
    confirmationNumbers: '.cb-confirmation-page > div > div > div:nth-child(3) > p, .cb-confirmation-page > div > div > div > p, .cb-confirmation-page .chakra-text',
    contentChangeTarget: ".cb-confirmation-page",
    confirmationMessageContainer: "#guestbook-confirm",
  },
  cancellation: {
    cancellationTarget: "NA",
    cancellationNumber: "NA",
    confirmationNumber: "NA",
  }
};

export default Selectors;
